import styled from "styled-components";

export const StyledComboCreator = styled.div`
    width: 100%;
    margin-bottom: 40px;
    .btn-holder {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 20px;
    }
`;
export const ComboCard = styled.div`
    width: 100%;
    border-radius: 20px;
    padding: 25px 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 25px;
    background-color: var(--white);
    box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.08);
    margin-bottom: 15px;

    @media (min-width: 768px) {
        flex-direction: row;
    }

    .combo-img {
        width: 100px;
        height: 100px;
        border-radius: 10px;
    }

    .details-wrap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        @media (min-width: 680px) {
            flex-direction: row;
        }
    }

    .col-1 {
        @media (max-width: 680px) {
            text-align: center;
        }
        .title-wrap {
            display: flex;
            align-items: center;
            gap: 15px;
            margin-bottom: 10px;
            @media (max-width: 680px) {
                justify-content: center;
            }

            .title {
                color: var(--text-color);
                margin: 0;
                font-size: 24px;
                line-height: 28px;
                font-weight: 400;
            }
            .status {
                border-radius: 30px;
                padding: 7px 10px;
                font-size: 12px;
                line-height: 16px;
                font-weight: 400;
            }
            .popular {
                background: rgba(245, 126, 42, 0.2);
                color: var(--primary);
            }
            .active {
                background: rgba(39, 196, 83, 0.2);
                color: rgba(39, 196, 83, 1);
            }
            .inactive {
                background: rgba(119, 119, 119, 0.2);
                color: rgba(119, 119, 119, 1);
            }
        }
        .desc {
            display: block;
            color: var(--text-color);
            margin-bottom: 20px;
            font-size: 16px;
            line-height: 20px;
            font-weight: 300;
        }
        .includes {
            display: block;
            margin-bottom: 11px;
            color: rgba(119, 119, 119, 1);
            font-size: 15px;
            line-height: 19px;
            font-weight: 300;
            strong {
                color: var(--text-color);
                font-weight: 500;
            }
        }
        .duration-wrap {
            display: flex;
            align-items: center;
            gap: 15px;
            @media (max-width: 680px) {
                justify-content: center;
            }
            .duration {
                display: flex;
                align-items: center;
                gap: 5px;
                color: var(--text-color);
                font-size: 13px;
                line-height: 17px;
                font-weight: 300;
            }
        }
    }

    .col-2 {
        text-align: center;
        @media (min-width: 681px) {
            text-align: right;
        }
        .price {
            color: rgba(39, 196, 83, 1);
            font-size: 24px;
            line-height: 28px;
            font-weight: 500;
            margin-bottom: 10px;
        }
        .discount {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            color: rgba(39, 196, 83, 1);
            font-size: 15px;
            line-height: 19px;
            font-weight: 500;
            margin-bottom: 15px;
            @media (min-width: 681px) {
                justify-content: flex-end;
            }
            del {
                color: var(--text-color);
            }
        }
        .sold {
            display: block;
            color: rgba(119, 119, 119, 1);
            font-size: 14px;
            line-height: 18px;
            font-weight: 300;
            margin-bottom: 15px;
        }
        .btn-wrap {
            display: flex;
            align-items: center;
            gap: 15px;
            .btn {
                color: var(--text-color);
                border: 1px solid rgba(236, 236, 236, 1);
                padding: 5px 10px;
            }
            .deleteIcon,
            .editIcon {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 28px;
                height: 28px;
                border-radius: 10px;
                cursor: pointer;
            }
            .deleteIcon {
                background: rgba(255, 45, 45, 0.15);
            }
            .editIcon {
                background: rgba(253, 229, 212, 1);
            }
        }
    }
`;
